import { Box, FormControl, RadioGroup } from '@mui/material'
import AdxCheckbox from 'components/custom/AdxCheckbox'
import AdxFormControlLabel from 'components/custom/AdxFormControlLabel'
import AdxFormModal from 'components/reusable/modal/AdxFormModal'
import React from 'react'

function ACNonCustomEvaluation({
  isModalOpen,
  handleClose,
  allEvalData,
  nonCustomValue,
  handleNonCustomEval,
  handleAddNonCustomEval,
  nonCustomDisabled,
}) {
  const nonCustomEval = []

  allEvalData?.map((item) => {
    if (item?.participant_match_type_id !== 4) nonCustomEval.push(item)
  })

  return (
    <>
      <AdxFormModal
        open={isModalOpen}
        onClose={handleClose}
        handleClose={handleClose}
        title="Add from non custom matching evaluation"
        subtitle="Choose evaluations to be added into this appraisal"
        disableAutoFocus={true}
        enableFooter
        actionText="Add"
        handleAction={() => {
          handleClose()
          handleAddNonCustomEval()
        }}
        sxModal={{ minWidth: 600 }}
        actionButtonDisabled={nonCustomValue.length === 0 ? true : false}
      >
        <Box display="flex" flexDirection="column">
          <FormControl>
            <RadioGroup>
              {nonCustomEval?.map((item, index) => (
                <Box sx={{ py: 0.5 }} key={index}>
                  <AdxFormControlLabel
                    type="no-fill"
                    selected={nonCustomValue}
                    value={item.id}
                    control={
                      <AdxCheckbox
                        onChange={handleNonCustomEval}
                        checked={nonCustomDisabled?.some(
                          (disabledItem) =>
                            disabledItem.title === item.title || disabledItem === item.id
                        )}
                      />
                    }
                    label={item.title}
                    disabled={nonCustomDisabled?.some(
                      (disabledItem) =>
                        disabledItem.title === item.title || disabledItem === item.id
                    )}
                  />
                </Box>
              ))}
            </RadioGroup>
          </FormControl>
        </Box>
      </AdxFormModal>
    </>
  )
}

export default ACNonCustomEvaluation
